import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "className", "videoTag", "videoAttributes", "isAutoPlay", "isLoop", "isSplit"];
import React from 'react';
import classNames from 'classnames';
var VideoWithOverlay = function VideoWithOverlay(_ref) {
  var children = _ref.children,
    className = _ref.className,
    videoTag = _ref.videoTag,
    videoAttributes = _ref.videoAttributes,
    isAutoPlay = _ref.isAutoPlay,
    isLoop = _ref.isLoop,
    isSplit = _ref.isSplit,
    attrs = _objectWithoutPropertiesLoose(_ref, _excluded);
  var classes = classNames('videoBanner', 'position-relative', 'text-center', 'p-4', 'overflow-hidden', className);
  var autoPlay = {
    autoplay: 'true',
    muted: 'muted' //this needs to be set otherwise, autoplay will not work
  };
  var autoLoop = {
    loop: 'loop'
  };
  return /*#__PURE__*/React.createElement("section", _extends({
    className: classes
  }, videoAttributes), /*#__PURE__*/React.createElement("div", {
    className: "videoBanner__wrapper d-flex w-100 h-100 " + (isSplit ? 'pt-4' : 'align-items-center')
  }, videoAttributes && /*#__PURE__*/React.createElement("video", _extends({
    className: "videoBanner__image"
  }, isAutoPlay && autoPlay, isLoop && autoLoop), videoAttributes.map(function (video, index) {
    return /*#__PURE__*/React.createElement("source", {
      src: video.src,
      type: video.type
    });
  })), children && /*#__PURE__*/React.createElement("div", {
    className: "videoBanner__content d-flex flex-column mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "videoBanner__content__container"
  }, children))));
};
export default VideoWithOverlay;
VideoWithOverlay.defaultProps = {
  videoTag: 'video'
};